export class VideoRecorder {
    constructor(audioEngine, canvas) {
        this.engine = audioEngine;
        this.canvas = canvas;
        this.mediaRecorder = null;
        this.chunks = [];
        this.isRecording = false;
        this.streamDestination = null;
    }

    getSupportedVideoMimeType() {
        const isApple = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
        
        let types = [];
        
        if (isApple) {
            types = [
                "video/mp4",
                "video/webm;codecs=vp9",
                "video/webm"
            ];
        } else {
            types = [
                "video/webm;codecs=vp9",
                "video/webm;codecs=vp8",
                "video/webm",
                "video/mp4"
            ];
        }
        
        for (const type of types) {
          if (MediaRecorder.isTypeSupported(type)) {
            return type;
          }
        }
        throw new Error("No supported video mimeType found.");
    }

    setup() {
        if (!this.engine.ctx) return false;
        
        // Invalidate if context changed (e.g. after reset)
        if (this.streamDestination && this.streamDestination.context !== this.engine.ctx) {
            this.streamDestination = null;
        }

        // Ensure Audio Stream Available
        if (!this.streamDestination) {
            this.streamDestination = this.engine.ctx.createMediaStreamDestination();
            if (this.engine.masterGain) {
                this.engine.masterGain.connect(this.streamDestination);
            } else {
                return false;
            }
        }
        return true;
    }

    start() {
        if (!this.setup()) return false;
        
        this.chunks = [];
        
        // 1. Capture Video from Canvas
        const videoStream = this.canvas.captureStream(30); // 30 FPS
        
        // 2. Capture Audio from Engine
        const audioStream = this.streamDestination.stream;
        
        // 3. Combine
        const combinedStream = new MediaStream([
            ...videoStream.getVideoTracks(),
            ...audioStream.getAudioTracks()
        ]);
        
        // 4. Init Recorder
        this.selectedMimeType = this.getSupportedVideoMimeType();
        const options = { mimeType: this.selectedMimeType };

        try {
            this.mediaRecorder = new MediaRecorder(combinedStream, options);
        } catch (e) {
            console.error("Video MediaRecorder failed:", e);
            return false;
        }

        this.mediaRecorder.ondataavailable = (e) => {
            if (e.data.size > 0) {
                this.chunks.push(e.data);
            }
        };

        this.mediaRecorder.onstop = () => {
            this.download();
        };

        this.mediaRecorder.start();
        this.isRecording = true;
        return true;
    }

    stop() {
        if (this.mediaRecorder && this.isRecording) {
            this.mediaRecorder.stop();
            this.isRecording = false;
            return true;
        }
        return false;
    }

    download() {
        const mimeType = this.selectedMimeType || 'video/webm';
        const blob = new Blob(this.chunks, { type: mimeType });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        
        // Determine extension
        let ext = 'webm';
        if (mimeType.includes('mp4')) ext = 'mp4';

        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        a.download = `sonic-envelope-video-${timestamp}.${ext}`;
        
        a.click();
        
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
}
